/**
 * TOURX logo — uses the actual brand PNG at /tourx-logo.png
 * Place the real logo file in frontend/public/tourx-logo.png
 */
export function TourxLogo({ height = 32 }: { height?: number }) {
  return (
    <img
      src="/tourx-logo.png"
      alt="TOURX"
      style={{ height }}
      className="object-contain"
    />
  );
}
